module.exports = __webpack_public_path__ + "static/media/tasklist_1576044751996.2c90790b.png";